import React from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ColorData from "Components/CstmTheme/ColorData";

type DesktopProps = {
  // open: boolean;
  // onClose: () => void;
  navItems: {
    label: string;
    submenu: string[];
  }[];
  onNavigate: (item: string) => void;
  // expandedItems: { [key: string]: boolean };
  // onExpandClick: (itemLabel: string) => void;
};
const DesktopNav: React.FC<DesktopProps> = ({
  //  open,
  //   onClose,
  navItems,
  onNavigate,
  // expandedItems,
  // onExpandClick,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);

  const handleHover = (
    event: React.MouseEvent<HTMLButtonElement>,
    index: number
  ) => {
    if (!isMobile) {
      setAnchorEl(event.currentTarget);
      setOpenIndex(index);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenIndex(null);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap', // 👈 stay in one row
        overflowX: 'auto',   // 👈 optional: horizontal scroll if overflow
        // Reduce gap between items
        alignItems: 'center',
      }}
    >
      {navItems.map((item, index) => (
        <Box
          key={item.label}
          onMouseLeave={handleClose}
          sx={{ position: "relative", whiteSpace: "nowrap" }}
        >
          <Button
            key={item.label}
            // onMouseEnter={(e) => handleHover(e, index)}
            // onClick={(e) => isMobile && handleHover(e, index)}
            onClick={(e) => handleHover(e, index)}
            endIcon={<ArrowDropDownIcon sx={{ fontSize: '1rem' }} />}
            sx={{
              fontSize: "1rem",
              fontWeight: '500',
              color: ColorData.text.primary,
              textTransform: 'none',
              whiteSpace: 'nowrap',
              //  fontSize: '16px',
              '& .MuiButton-endIcon': {
                marginLeft: 0,
              },

            }}
          >
            {item.label}
          </Button>

          <Menu
            anchorEl={anchorEl}
            open={openIndex === index}
            onClose={handleClose}
            // IMPORTANT: Remove or set disablePortal={false}
            // disablePortal
            MenuListProps={{
              onMouseEnter: () => !isMobile && setOpenIndex(index),
              onMouseLeave: handleClose,
              sx: {
                padding: '3px 0',
                // borderRadius: '2px',
                // minWidth: '180px',
              },
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            PaperProps={{
              sx: {
                mt: 0.5,
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                borderRadius: '8px',
                bgcolor: "#a24857",
                color: "#fff",
                // You could explicitly set zIndex here if necessary, but typically not needed when not disabling portal
                // zIndex: theme.zIndex.tooltip + 1, // Example, adjust as needed
              },
            }}
          >
            {item.submenu.map((subItem) => (
              <MenuItem
                key={subItem}
                onClick={() => {
                  handleClose();
                  onNavigate(subItem);
                }}
                sx={{
                  fontSize: '0.875rem',
                  // padding: '8px 8px',
                  minHeight: '2rem',
                  // backgroundColor: ColorData.primary.main,
                  // color: ColorData.text.secondary,

                  "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },

                }}
              >
                <Typography
                  color="background.default"
                  sx={{ fontSize: "14px" }}
                >
                  {subItem}
                </Typography>

              </MenuItem>
            ))}
          </Menu>
        </Box>
      ))}
    </Box>
  );
};

export default DesktopNav;